exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1PNMZ,._3G2DH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1PNMZ ._3Lg2h{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row}._1PNMZ ._3Lg2h,._3G2DH ._3Lg2h{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;list-style:none;margin:0}._3G2DH ._3Lg2h{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}._3Lg2h{font-weight:400}.f2F2C{font-size:14px;color:#c4c4c4}", ""]);

// exports
exports.locals = {
	"root": "_1PNMZ",
	"rootMobile": "_3G2DH",
	"citiesList": "_3Lg2h",
	"title": "f2F2C"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/Footer/LocationList/LocationList.css
// module id = 1379
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46